export default __webpack_public_path__ + "static/media/cool_3.bf5e797f.jpg";